import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getFirestore} from "@firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAba_uzQawjnnTYC96JeNb_kbeRJQiBW70",
    authDomain: "rkkp-uwm.firebaseapp.com",
    projectId: "rkkp-uwm",
    storageBucket: "rkkp-uwm.appspot.com",
    messagingSenderId: "498574582009",
    appId: "1:498574582009:web:2c6481535c620d32200228"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
